export class HotelRemarksController {}
